<template>
  <div class="animated fadeIn">
    <div class="page-header d-flex" style="margin: 12px 12px 5px 12px;">
      <h4 class="page-title">
        <i class="fas fa-list-alt"></i>
        정책
      </h4>
      <ul class="breadcrumbs ml-auto">
          <li class="nav-home mr-1">
              <a href="#">
                <i class="fas fa-home text-muted"></i>
              </a>
          </li>
          <li class="nav-item">
              <a class="font_15" href="#">WMDS</a>
          </li>
          <li class="separator">
              <i class="fa fa-angle-right"></i>
          </li>
          <li class="nav-item">
              <a class="font_15 font-weight-bold" href="#">Policy</a>
          </li>
      </ul>
    </div>
    <b-card>
      <!-- <template slot="header">
        <i class='fa fa-align-justify'></i> 정책 목록
      </template> -->
      <!-- detail search start -->
      <b-card v-show="so.adv">
        <b-row>
          <b-col md="6">
            <b-form-group>
              <label for="opt_date"> 등록일
                <b-button size="sm" variant="info" @click="set_sd('', 'created_at')"><i class="fa fa-remove"></i></b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1d', 'created_at')">-1D</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1w', 'created_at')">-1W</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1m', 'created_at')">-1M</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('w', 'created_at')">W</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('m', 'created_at')">M</b-button>
              </label>
              <b-form inline>
                <date-picker @change="refresh" v-model="so.opt.created_at_sd" style="width: 140px" :lang="custom.lang.ko" :confirm="false" :first-day-of-week="1"></date-picker>
                ~
                <date-picker @change="refresh" v-model="so.opt.created_at_ed" style="width: 140px" :lang="custom.lang.ko" :confirm="false" :first-day-of-week="1"></date-picker>
              </b-form>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group>
              <label for="opt_visit"> 마지막 수정일
                <b-button size="sm" variant="info" @click="set_sd('', 'updated_at')"><i class="fa fa-remove"></i></b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1d', 'updated_at')">-1D</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1w', 'updated_at')">-1W</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1m', 'updated_at')">-1M</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('w', 'updated_at')">W</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('m', 'updated_at')">M</b-button>
              </label>
              <b-form inline>
                <date-picker @change="refresh" v-model="so.opt.updated_at_sd" style="width: 140px" :lang="custom.lang.ko" :confirm="false" :first-day-of-week="1"></date-picker>
                ~
                <date-picker @change="refresh" v-model="so.opt.updated_at_ed" style="width: 140px" :lang="custom.lang.ko" :confirm="false" :first-day-of-week="1"></date-picker>
              </b-form>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12">
            <b-form-group>
              <label for="opt_description">설명</label>
              <b-form-input @keydown.enter="refresh" type="text" id="opt_description" v-model="so.opt['description']"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12">
            <label for="ph_search_opt_type">검색 옵션</label>
            <b-form-group>
              <b-form-radio-group id="ph_search_opt_type" v-model="so.opt['match_type']" name="ph_search_opt_type">
                <b-form-radio value="and">[AND]:모두 포함</b-form-radio>
                <b-form-radio value="or">[OR]:하나라도 포함</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
          </b-col>
        </b-row>

        <b-form-group class="float-right">
          <b-button class="btn-add" size="sm" variant="success" @click="refresh"> 검색 </b-button>
          <b-button size="sm" variant="warning" @click="reset"> 초기화 </b-button>
          <b-button size="sm" variant="secondary" @click="search_opt"> 닫기 </b-button>
        </b-form-group>
      </b-card>
      <!-- detail search end -->
      <b-row>
        <b-col sm="6">
          <span class="text-center" v-b-tooltip.hover title="한 페이지에 보여질 개수를 지정합니다">
            표시 수
            <select v-model="so.perPage" @change="refresh">
              <option value="15">기본 15</option>
              <option value=10>10</option>
              <option value=50>50</option>
              <option value=100>100</option>
            </select>
          </span>
        </b-col>
        <b-col sm="6">
          <b-input-group size="sm">
            <b-input-group-prepend>
              <b-btn variant="outline-secondary" @click="refresh()"><i class="fa fa-refresh"></i></b-btn>
              <b-btn variant="outline-secondary" @click="reset()"><i class="fa fa-remove"></i></b-btn>
              <b-input-group-text size="sm" variant="outline-secondary">설명</b-input-group-text>
            </b-input-group-prepend>
            <b-form-input :disabled="so.adv" v-model="so.sv" @keyup.native.enter="refresh"></b-form-input>
            <b-input-group-append>
              <b-btn variant="outline-secondary" @click="refresh()"><i class="fa fa-search"></i></b-btn>
              <b-btn variant="outline-secondary" @click="so.adv = !so.adv; so.sv = ''"><i class="fa" :class="{'fa-search-plus': !so.adv, 'fa-search-minus': so.adv }"> 상세검색</i></b-btn>
            </b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>
      <hr>
      <b-table hover striped small responsive="sm" ref="_list" show-empty empty-text="not found" class="table-responsive table_add"
        :items="getItems" :fields="fields_ko" :current-page="so.currentPage" :per-page="so.perPage" :sortBy="so.sk">
        <template slot="id" slot-scope="row">{{startRow - row.index}}</template>
        <template slot="created_at" slot-scope="row">{{row.item.created_at | sdate}}</template>
        <template slot="count" slot-scope="row">
          사용중 사이트 : {{row.item.count | number}}
        </template>
        <template slot="description" slot-scope="row" v-if="row.item.policy">
          <a href="javascript:void(0)" class="a_tag" @click="detail(row.item)">
            {{row.item.description  || '-'}}
          </a>
        </template>
        <template slot="policy" slot-scope="row" v-if="row.item.policy">{{row.item.policy.limit | number}}</template>
        <template slot="updated_at" slot-scope="row">{{row.item.updated_at | datetime}}</template>
        <template slot="func" slot-scope="row">
          <b-btn v-if="use_view == false" @click="detail(row.item)" size="sm" variant="outline-primary">선택</b-btn>
          <b-btn v-else @click="detail(row.item)" size="sm" variant="outline-primary">더 보기</b-btn>
        </template>
      </b-table>
      <hr>
      <b-row>
        <b-col md="4"></b-col>
        <b-col md="4">
          <b-pagination size="sm"  align="center" :total-rows="rowCount" :per-page="so.perPage" v-model="so.currentPage" prev-text="<" next-text=">" />
        </b-col>
        <b-col md="4" v-if="use_view != false">
          <div class="pull-right">
            <b-button class="btn-add" size="sm" :limit="10" variant="success" @click="$router.push({ name: 'wmds_policy', params: { id : 'add' } })"> 등록 </b-button>
          </div>
        </b-col>
      </b-row>
    </b-card>

    <router-view @hide-parent="hideList($event)" @refresh="refresh()"></router-view>
  </div>
</template>

<script>
import App from './app.js'; export default Object.assign({}, App);
</script>
